/**
 * Which help entries describe each page in the navigation.
 *
 * ── WHY THIS FILE EXISTS (David, 10 Oct 2026; migration 155) ────────────────
 *
 * Ask One answers "how does the hub work" from the platform help corpus
 * (docs/platform-help-corpus.md in the docs repo, loaded by migrations). From
 * 25 Sep to 10 Oct nobody added to it while 114-154 shipped photo contests,
 * the Gallery, One Question and the digital card, so on launch weekend One
 * knew none of them and ten of its entries were false. The rule that would
 * have caught it was "remember to update the corpus", and nobody did.
 *
 * So it is a test instead. web/test/hub-render.test.tsx reads every route in
 * the shell's navigation (AppShell, TabBar, IdentityMenu) and fails when a
 * route is missing from this map, or when a key here is not loaded by any
 * migration or seed. ADDING A PAGE TO THE NAVIGATION THEREFORE FAILS THE
 * BUILD UNTIL ITS HELP ENTRY EXISTS: write the entry in the corpus file, load
 * it with a migration (rule 7 of that file - 155 is the template), and list
 * its key here.
 *
 * This is only the floor. A changed BEHAVIOUR on an existing page is not
 * caught by any test; that is the fifth close-session question in
 * CONVENTIONS.md. This map catches the case that is mechanical to catch.
 *
 * Keys are entry_key values in public.platform_help_entry. Route '' is the hub.
 */
export const HELP_COVERAGE: Record<string, readonly string[]> = {
  '': ['feed_who_sees', 'oneq_what', 'video_welcome'],
  wiki: ['wiki_what', 'askone_what'],
  stars: ['stars_what', 'stars_earn', 'store_spend_on'],
  contests: ['photo_contest_what', 'photo_contest_themed'],
  'photos/gallery': ['gallery_what', 'gallery_add', 'gallery_map', 'photo_add_location'],
  profile: ['profile_what', 'card_what', 'email_why', 'email_stop', 'email_when_waiting'],
  // 165. Not a NAV route (the identity menu opens it); listed so its help is named.
  terms: ['terms_what', 'star_one_terms'],
  // 337 (HLP-43). Help: tickets, feedback, your tickets.
  help: ['help_what', 'help_ticket', 'help_feedback', 'support_your_questions'],
  // 339 (HLP-45). Guides: where they are, and who sees which.
  'help/guides': ['guides_where', 'guides_who'],
  support: ['support_your_questions', 'role_desk'],
  'support/ask-one': ['role_desk'],
  'support/one-question': ['oneq_what', 'role_desk'],
  // SHL-33 (11 Oct): #/admin is the admin home; People and roles is #/admin/people.
  admin: ['role_where'],
  'admin/people': ['role_people', 'role_view_as'],
  'admin/notices': ['role_notices'],
  'admin/shop': ['role_admin_pages'],
  'admin/stars': ['role_admin_pages'],
  moderation: ['role_admin_pages'],
  // 196 (ACC-8).
  'admin/audit': ['role_audit'],
  // 310.
  surveys: ['survey_what', 'survey_answer', 'survey_make', 'survey_live', 'survey_archive', 'survey_ideas'],
  // 301.
  'admin/usage': ['role_usage', 'usage_counted'],
}
